// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notifications[data-v-e149f236]{position:fixed;top:10px;left:10px;z-index:10;box-shadow:0 2px 4px 1px rgba(0,0,0,.1)}", ""]);
// Exports
module.exports = exports;
